import { inject } from "fw";

import { Manager } from "./manager";
import { FeatureFlagSet, FeatureFlagChangeSet, FeatureFlagOrgsSearchInfo, FeatureFlagImplicitOrgSearchInfo } from "models/feature-flags";

import { createFrom } from "fw-model";

@inject
export class AtsFeatureFlagsRepository {
    constructor(private s: Manager) {}

    public async getDefaults() {
        const res = await this.s.get<FeatureFlagSet>("ats/feature-flag-defaults");
        return res.body;
    }

    public async getFlagDetails(
        flag: string,
        filter: string,
        sort: string = null,
        previousPageToken: string = null,
        nextPageToken: string = null,
        pageSize: number = 20
    ) {
        const res = await this.s.get<FeatureFlagOrgsSearchInfo>(`ats/feature-flag/${flag}`, {
            filter,
            sort,
            previousPageToken,
            nextPageToken,
            pageSize
        });
        return createFrom(FeatureFlagOrgsSearchInfo, res.body);
    }

    public async getFlagImplicits(
        flag: string,
        filter: string,
        search: string,
        sort: string = null,
        previousPageToken: string = null,
        nextPageToken: string = null,
        pageSize: number = 20
    ) {
        const res = await this.s.get<FeatureFlagImplicitOrgSearchInfo>(`ats/feature-flag/${flag}/implicit`, {
            filter,
            search,
            sort,
            previousPageToken,
            nextPageToken,
            pageSize
        });
        return createFrom(FeatureFlagImplicitOrgSearchInfo, res.body);
    }

    public async putDefaults(changeSet: FeatureFlagChangeSet) {
        const res = await this.s.put<FeatureFlagSet>("ats/feature-flag-defaults", changeSet);
        return res.body;
    }

    public async putOrganizationFeatureFlag(organizationId: string, changeSet: FeatureFlagChangeSet) {
        const res = await this.s.put<FeatureFlagSet>(`ats/feature-flag/organization/${organizationId}`, changeSet);
        return res.body;
    }

    public async getOrganizationFeatureFlags(organizationId: string) {
        const res = await this.s.get<FeatureFlagChangeSet>(`ats/feature-flag/organization/${organizationId}`);
        return res.body;
    }
}
